// Mirrors OrderService.resolve_unit_price on the backend: once a cart line's
// quantity meets wholesale_min_quantity, wholesale_price applies instead of
// base_price. Keep this in sync with app/services/order.py if that changes.
export function resolveUnitPrice(item, quantity) {
  const wholesalePrice = Number(item.wholesale_price);
  const wholesaleMinQuantity = Number(item.wholesale_min_quantity);
  const basePrice = Number(item.base_price) || 0;

  if (
    item.wholesale_price != null &&
    item.wholesale_min_quantity != null &&
    Number.isFinite(wholesalePrice) &&
    Number.isFinite(wholesaleMinQuantity) &&
    quantity >= wholesaleMinQuantity
  ) {
    return wholesalePrice;
  }
  return basePrice;
}



// Drives the wholesale notification (product detail + checkout). Returns
// null when the item has no valid wholesale tier at all. Otherwise returns
// either the "you're eligible, here's your total saving at this quantity"
// state, or the "buy N more to unlock and save Y" state.
export function getWholesaleInfo(item, quantity) {
  const wholesalePrice = Number(item.wholesale_price);
  const wholesaleMinQuantity = Number(item.wholesale_min_quantity);
  const basePrice = Number(item.base_price) || 0;

  const hasWholesaleTier =
    item.wholesale_price != null &&
    item.wholesale_min_quantity != null &&
    Number.isFinite(wholesalePrice) &&
    Number.isFinite(wholesaleMinQuantity) &&
    wholesaleMinQuantity > 0 &&
    wholesalePrice < basePrice;

  if (!hasWholesaleTier) return null;

  const qty = Math.max(0, Number(quantity) || 0);

  if (qty >= wholesaleMinQuantity) {
    return {
      eligible: true,
      unitPrice: wholesalePrice,
      minQuantity: wholesaleMinQuantity,
      totalSaving: (basePrice - wholesalePrice) * qty,
    };
  }

  return {
    eligible: false,
    unitPrice: wholesalePrice,
    minQuantity: wholesaleMinQuantity,
    unitsNeeded: wholesaleMinQuantity - qty,
    potentialSaving: (basePrice - wholesalePrice) * wholesaleMinQuantity,
  };
}